import React, { useEffect, useState } from 'react';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Button,
  Container,
  Row,
  Col,
  Spinner
} from 'reactstrap';
import { Filter } from 'react-feather';
import { getCamelCaseWord } from '../static/brands_wholesalers_data';

const MultiSelectFilterDropDown = ({
  data = {},
  btnWhite,
  filters = {},
  isLoading,
  onFilterApply
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState(filters || []);
  const isFiltersApplied = Object.values(filters).length > 0;
  const isDataEmpty = Object.values(data).every((arr) => Array.isArray(arr) && arr.length === 0);

  useEffect(() => {
    setSelectedFilters(filters);
  }, [JSON.stringify(filters)]);

  const toggle = () => setDropdownOpen(prevState => !prevState);

  const handleFilterSelect = (key, item) => {
    const isSingleSelectColumn = key === 'sort_by' || key === 'profile_status';
    const value = item?.name;
    const selected = selectedFilters[key]?.find((i) => i === value);

    if (selected) {
      // Remove filter
      setSelectedFilters((prev) => ({
        ...prev,
        [key]: prev[key]?.filter((option) => option !== value),
      }));
    } else {
      // Add filter
      if (isSingleSelectColumn) {
        setSelectedFilters((prev) => ({
          ...prev,
          [key]: [value],
        }));
      } else {
        setSelectedFilters((prev) => ({
          ...prev,
          [key]: prev[key] ? [...prev[key], value] : [value],
        }));
      }
    }
  };

  const clearAllFilters = () => {
    setSelectedFilters({});
    onFilterApply({});
    setDropdownOpen(false);
  };

  const applyFilters = () => {
    onFilterApply(selectedFilters);
    setDropdownOpen(false);
  };

  const cancelFilters = () => {
    if (!isFiltersApplied) {
      setSelectedFilters([]);
    }
    setDropdownOpen(false);
  };

  const getPriorityColor = (priorityName) => {
    switch (priorityName) {
      case 'Idle': return '#999';
      case 'low': return '#4ECCC6';
      case 'medium': return '#579BFC';
      case 'high': return '#FF7748';
      default: return '#999';
    }
  };

  // Count the number of non-empty filter columns
  const nonEmptyColumnCount = Object.keys(data).filter(key =>
    Array.isArray(data[key]) && data[key].length > 0
  ).length;

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle
        style={{
          borderRadius: '6px',
          backgroundColor: btnWhite ? '#E0E0E0' : 'black',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        color="link"
      >
        <Filter color="#fff" size={20} />
        {isFiltersApplied && (
          <div
            style={{
              width: '8px',
              height: '8px',
              backgroundColor: '#2e99f2',
              borderRadius: '50%',
              position: 'absolute',
              top: '-3px',
              right: 0
            }}
          />
        )}
      </DropdownToggle>
      <DropdownMenu
        className="p-3"
        style={{
          maxWidth: '90vw',
          width: 'auto',
          minWidth: '500px'
        }}
      >
        {isLoading ? (
          <div className="d-flex justify-content-center py-5">
            <Spinner color="dark" />
          </div>
        ) : !isLoading && isDataEmpty ? (
          <div className="text-center text-muted py-3">
            No filters available
          </div>
        ) : (
          <>
            <Container fluid>
              <Row className="mb-3 align-items-center">
                <Col>
                  <h6 className="text-muted mb-0" style={{ fontSize: '14px' }}>Filters</h6>
                </Col>
                <Col className="text-end">
                  <Button
                    color="link"
                    size="sm"
                    className="text-priamry p-0"
                    onClick={clearAllFilters}
                  >
                    Clear all
                  </Button>
                </Col>
              </Row>

              <div
                style={{
                  display: 'flex',
                  overflowX: 'auto',
                  paddingBottom: '10px'
                }}
              >
                {Object.keys(data)?.map((key) => {
                  const filters = data[key];

                  if (filters?.length === 0) return null;

                  return (
                    <div
                      key={key}
                      style={{
                        minWidth: '200px',
                        marginRight: '20px',
                        flexShrink: 0
                      }}
                    >
                      <h6 className="text-muted" style={{ fontSize: '13px' }}>
                        {getCamelCaseWord(key)}
                      </h6>
                      <div
                        style={{
                          maxHeight: '300px',
                          overflowY: 'auto',
                          marginTop: 5,
                          paddingRight: '10px',
                          borderRight: '1px solid #e0e0e0'
                        }}
                      >
                        {filters?.map((item, i) => {
                          const isUsersColumn = key === "users";
                          const value = isUsersColumn ? item?.id : item?.name;
                          const selected = selectedFilters[key]?.find((i) => i === value);

                          return (
                            <Button
                              key={i}
                              color="link"
                              className="w-100 text-start d-flex justify-content-between align-items-center px-2 py-1 mb-1"
                              style={{
                                backgroundColor: selected ? '#ADDDFF' : '#F3F3F3',
                                textDecoration: 'none'
                              }}
                              onClick={() => handleFilterSelect(key, item)}
                            >
                              <div className="d-flex align-items-center">
                                <span
                                  className="text-truncate"
                                  style={{
                                    maxWidth: '120px',
                                    fontSize: '12px',
                                    color: '#546168'
                                  }}
                                >
                                  {getCamelCaseWord(item?.name)}
                                </span>
                              </div>
                              {key !== 'sort_by' ? (
                                <span
                                  className="text-muted"
                                  style={{ fontSize: '12px' }}
                                >
                                  {item.count}
                                </span>
                              ) : null}
                            </Button>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>

              <Row className="mt-3">
                <Col>
                  <Button
                    color="primary"
                    size="sm"
                    className="me-2"
                    onClick={applyFilters}
                  >
                    Apply
                  </Button>
                  <Button
                    color="primary"
                    size="sm"
                    outline
                    onClick={cancelFilters}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
            </Container>
          </>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

export default MultiSelectFilterDropDown;